import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Button,
  Container,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody
} from "reactstrap";
import Logo from "../Assets/images/logo.png";
import { deleteAllCookies } from "../Helpers/Utils";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggle = () => setIsOpen(!isOpen);

  // ACTIVE CHECK
  const isActive = (path) =>
    location.pathname === path ? "active" : "";

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    deleteAllCookies();
    window.location.href = "/";
  };

  return (
    <header className="main-header">
      <Container>
        <div className="header-inner">

          {/* LOGO */}
          <Link to="/">
            <img className="header-logo" src={Logo} alt="logo" />
          </Link>

          {/* DESKTOP MENU */}
          <ul className="header-menus d-none d-md-flex">
            <li className={isActive("/")}>
              <Link to="/">
                <i className="bx bx-store"></i>
                <span>Products</span>
              </Link>
            </li>

            <li className={isActive("/cart")}>
              <Link to="/cart">
                <i className="bx bx-cart"></i>
                <span>My Cart</span>
              </Link>
            </li>

            <li className={isActive("/orders")}>
              <Link to="/orders">
                <i className="bx bx-package"></i>
                <span>My Orders</span>
              </Link>
            </li>
          </ul>

          {/* DESKTOP LOGOUT */}
          <Button
            className="logout-btn d-none d-md-block"
            onClick={handleLogout}
          >
            Logout
          </Button>

          {/* MOBILE MENU ICON */}
          <button className="btn d-md-none fs-2" onClick={toggle}>
            <i className="bx bx-menu"></i>
          </button>
        </div>
      </Container>

      {/* MOBILE OFFCANVAS */}
      <Offcanvas
        isOpen={isOpen}
        toggle={toggle}
        direction="start"
        className="premium-offcanvas"
      >
        <OffcanvasHeader toggle={toggle} className="offcanvas-header-custom">
          <div className="offcanvas-logo-wrap">
            <img src={Logo} alt="BizCarto" />
            <span>BizCarto</span>
          </div>
        </OffcanvasHeader>

        <OffcanvasBody className="offcanvas-body-custom">
          <ul className="mobile-nav-list">
            <li className={isActive("/")}>
              <Link to="/" onClick={toggle}>
                <i className="bx bx-store"></i>
                <span>Products</span>
              </Link>
            </li>

            <li className={isActive("/cart")}>
              <Link to="/cart" onClick={toggle}>
                <i className="bx bx-cart"></i>
                <span>My Cart</span>
              </Link>
            </li>

            <li className={isActive("/orders")}>
              <Link to="/orders" onClick={toggle}>
                <i className="bx bx-package"></i>
                <span>My Orders</span>
              </Link>
            </li>

            <li className={isActive("/profile")}>
              <Link to="/profile" onClick={toggle}>
                <i className="bx bx-user"></i>
                <span>My Profile</span>
              </Link>
            </li>
          </ul>

          <div className="offcanvas-footer">
            <Button
              className="logout-btn w-100"
              onClick={() => {
                toggle();
                handleLogout();
              }}
            >
              <i className="bx bx-log-out"></i> Logout
            </Button>
          </div>
        </OffcanvasBody>
      </Offcanvas>
    </header>
  );
};

export default Header;
